var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useHoneycombTheme, Popover } from '@honeycomb/ui-core';
import { SEARCH_FIELD_POPOVER_INNER_PADDING, SEARCH_FIELD_SIZE } from '../../../../utils/style-constants';
import { SearchFieldPopoverContext } from './SearchFieldPopover.context';
const getEdgeOffset = (placement, innerPadding) => {
    switch (placement) {
        case 'bottom-start':
            return innerPadding * -1;
        case 'bottom-end':
            return innerPadding;
        default:
            return 0;
    }
};
const DYNAMIC_HEIGHT_BUFFER = 20;
// This Popup implementation is specifically for search unit fields. The popup offset is set to
// exactly align with the bottom of the search unit panel when it has a single row of fields.
export function SearchFieldPopover(_a) {
    var { children, placement = 'bottom-start', dynamicHeight, error = false, variant = 'below-field' } = _a, other = __rest(_a, ["children", "placement", "dynamicHeight", "error", "variant"]);
    const { theme } = useHoneycombTheme();
    const fieldHeight = theme.components.themes.FieldBase.size[SEARCH_FIELD_SIZE].height;
    const [rootElement, setRootElement] = React.useState(null);
    const innerPadding = SEARCH_FIELD_POPOVER_INNER_PADDING * theme.spacingUnit;
    const topOffset = variant === 'wrapping-field' ? (fieldHeight + innerPadding) * -1 : 0;
    let offset;
    if (variant === 'wrapping-field') {
        offset = {
            mainAxis: topOffset,
            crossAxis: getEdgeOffset(placement, innerPadding),
        };
    }
    else {
        offset = {
            // We want the top edge of the popup to align with the bottom of the search control.
            // If any of the fields are in the error state then the offset needs to be adjusted
            // to account for the additional height of the error label.
            mainAxis: error ? 28 : 16,
            // We want to offset the left alignment of the popup so that the inner container aligns with the edge of the field.
            crossAxis: getEdgeOffset(placement, SEARCH_FIELD_POPOVER_INNER_PADDING * theme.spacingUnit),
        };
    }
    // We want the inner scrollable panel to use all available height without overflowing the boundary.
    const handleDynamicSizing = (element) => (_availableWidth, availableHeight) => {
        // eslint-disable-next-line no-param-reassign
        element.style.maxHeight = `${availableHeight - DYNAMIC_HEIGHT_BUFFER}px`;
    };
    const context = React.useMemo(() => ({
        variant,
        setRootElement,
    }), [variant]);
    return (React.createElement(SearchFieldPopoverContext.Provider, { value: context },
        React.createElement(Popover, Object.assign({ placement: placement, offset: offset, shift: true, dismiss: true, onCalculateSpace: dynamicHeight && rootElement ? handleDynamicSizing(rootElement) : undefined }, other), children)));
}
